export default "__VITE_ASSET__63dc085d__"